<template>
  <v-btn
    fab
    dark
    color="primary"
    fixed
    bottom
    right
    @click="goToCreate"
    class="btn-add"
  >
    <v-icon>add</v-icon>
  </v-btn>
</template>

<script>
import router from '@/router'

export default {
  props: [
    'routeName'
  ],
  computed: {
    routeNameValue: {
      get () {
        return this.routeName
      }
    }
  },
  methods: {
    goToCreate () {
      router.push({ name: this.routeNameValue })
    }
  }
}
</script>

<style scoped>
@media only screen and (max-width: 960px) {
  .btn-add{
    bottom: 90px;
  }
}
</style>
